export const sizeWithGigabyteAbbreviationText = "qVb";
export const sizeWithMegabyteAbbreviationText = "rVb";
export const sizeWithKilobyteAbbreviationText = "sVb";
export const sizeWithByteAbbreviationText = "tVb";
export default {sizeWithGigabyteAbbreviationText,sizeWithMegabyteAbbreviationText,sizeWithKilobyteAbbreviationText,sizeWithByteAbbreviationText};